<template>

  <div class="page-header__title-block">

    <h1 class="page-header__title">

      <slot name="title">{{ title }}</slot>

    </h1>

    <p v-if="subtitle || $slots.subtitle" class="page-header__subtitle">

      <slot name="subtitle">{{ subtitle }}</slot>

    </p>

    <div v-if="$slots['title-extra']" class="page-header__title-extra">

      <slot name="title-extra" />

    </div>

  </div>

</template>



<script>

export default {

  name: "PageHeader",

  props: {

    title: { type: String, default: "" },

    subtitle: { type: String, default: "" },

  },

};

</script>


